import { useEffect } from 'react';

import usePrevious from '~/src/common/hooks/usePrevious';
import { useNiceModal } from '~/src/common/services/ModalsManager';

export const useProductContentRefresh = (refresh: () => void) => {
  // Permet de refresh le produit si on est passé par
  // la modale de changement addr ou creneau
  const { visible: visibleDeliveryAddress } = useNiceModal('delivery-address-modal');
  const { visible: visibleSelectSlot } = useNiceModal('delivery-select-slot-modal');
  const isVisiblePreviousDeliveryAddress = usePrevious(visibleDeliveryAddress);
  const isVisiblePreviousSelectSlot = usePrevious(visibleSelectSlot);
  useEffect(() => {
    if (
      (!visibleDeliveryAddress && isVisiblePreviousDeliveryAddress) ||
      (!visibleSelectSlot && isVisiblePreviousSelectSlot)
    )
      refresh();
  }, [
    visibleDeliveryAddress,
    isVisiblePreviousDeliveryAddress,
    visibleSelectSlot,
    isVisiblePreviousSelectSlot,
    refresh,
  ]);
};
